import { formatChain } from 'src/constants/ConversionUtils'
import BlockchainIcon from 'src/assets/components/BlockchainIcon'
import 'src/components/shared/BlockchainWithIcon.css'

type blockchainProps = {
  blockchain: string
}

export const BlockchainWithIcon = ({ blockchain }: blockchainProps) => {
  return (
    <div className={'blockchain-with-icon'}>
      <BlockchainIcon blockchain={blockchain} className={'blockchain-icon'} /> {formatChain(blockchain)}
    </div>
  )
}
